// Class to preload all the assets
// Remember you can load this assets in another scene if you need it
export class Preloader extends Phaser.Scene {
    constructor() {
        super({ key: "Preloader" });
    }

    preload() {

    //// Define dimensions for the progress bar
    // const progressBarWidth = 400;
    // const progressBarHeight = 20;
    // const centerX = this.cameras.main.width / 2;
    // const centerY = this.cameras.main.height / 2;

    // // Create a graphics object to represent the progress bar background
    // const progressBox = this.add.graphics();
    // progressBox.fillStyle(0x222222, 0.8);
    // progressBox.fillRect(centerX - progressBarWidth / 2, centerY - progressBarHeight / 2, progressBarWidth, progressBarHeight);

    // // Create a graphics object to represent the progress bar itself
    // const progressBar = this.add.graphics();

    // // Add loading text above the progress bar
    // const loadingText = this.add.text(centerX, centerY - 50, 'Loading...', {
    //     fontSize: '20px',
    //     fill: '#ffffff'
    // }).setOrigin(0.5);

    // // Add percentage text on top of the progress bar
    // const percentText = this.add.text(centerX, centerY, '0%', {
    //     fontSize: '18px',
    //     fill: '#ffffff'
    // }).setOrigin(0.5);

    // // Add an event listener to update the progress bar as assets are loaded
    // this.load.on('progress', (value) => {
    //     // Clear previous progress bar and draw new one
    //     progressBar.clear();
    //     progressBar.fillStyle(0xffffff, 1);
    //     progressBar.fillRect(
    //         centerX - progressBarWidth / 2,
    //         centerY - progressBarHeight / 2,
    //         progressBarWidth * value,
    //         progressBarHeight
    //     );

    //     // Update percentage text
    //     percentText.setText(parseInt(value * 100) + '%');
    // });

    // // Add an event listener to handle completion of asset loading
    // this.load.on('complete', () => {
    //     // Clean up progress bar visuals
    //     progressBar.destroy();
    //     progressBox.destroy();
    //     loadingText.destroy();
    //     percentText.destroy();
    // });

        // Load all the assets
        this.load.setPath("assets");
   
        //this.load.script('webfont', 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js');

        //this.load.bitmapFont('oswald', 'fonts/Oswald-700.png', 'fonts/Oswald-700.json');

 
        this.load.multiatlas('pack', 'lotto-pack.json');

        this.load.image("player-profile-image", `user-profile-hold.png`)

        this.load.image("lotto-bg", "lotto-bg-xl-3.webp");

        this.load.image("view-history", "view-history.png");

        this.load.image("second-bg", "second-bg-3.webp");

        this.load.image("no-draw", "no-draw.webp");

        this.load.audio('button-click', [
            "button-click.ogg",
            "button-click.mp3"
        ]);

        //this.load.font('Montserrat', 'assets/Montserrat-VariableFont_wght.ttf', 'truetype');
        this.load.font("Oswald",'fonts/Oswald-VariableFont_wght.ttf', 'truetype');
        this.load.font('Montserrat', 'fonts/Montserrat-VariableFont_wght.ttf', 'truetype');
        
        //this.load.image('Oswald-700', '/fonts/Oswald-700-last.png');        
        
        // Load the bitmap font with the JSON configuration
        this.load.bitmapFont('oswald2', 'fonts/Oswald-Bold.png', 'fonts/Oswald-Bold.xml');
        this.load.bitmapFont('Oswald-Medium', 'fonts/Oswald-Medium.png', 'fonts/Oswald-Medium.xml');
        this.load.bitmapFont('Oswald-Regular', 'fonts/Oswald-Regular.png', 'fonts/Oswald-Regular.xml');
        this.load.bitmapFont('Montserrat-Medium', 'fonts/Montserrat-Medium.png', 'fonts/Montserrat-Medium.xml');
        this.load.bitmapFont('Montserrat-Bold', 'fonts/Montserrat-Bold.png', 'fonts/Montserrat-Bold.xml');
        
        
        // this.LoadProgress = 0
        // // Event to update the loading bar
        // this.load.on("progress", (progress) => {
        //     console.log("Loading: " + Math.round(progress * 100) + "%");
        //     this.LoadProgress = Math.round(progress * 100)
        // });
    }

    create() {

       

        

        // When all the assets are loaded go to the next scene
        this.scene.start("SplashScene");
    }

}